import { EncryptStorage } from 'encrypt-storage';
import { config } from "./Config";
export const encStorage = new EncryptStorage(config.encsecretKey, {

});